import { FC } from "react";
import { COLORS } from "shared/consts";

type InformationIconProps = {
    fill?: string;
    width?: number | string;
    height?: number | string;
    className?: string;
};

export const InformationIcon: FC<InformationIconProps> = ({
    fill = COLORS.FG.DEFAULT,
    width = 17,
    height = 17,
    className,
}) => {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.4167 8.33333C15.4167 12.2454 12.2454 15.4167 8.33333 15.4167C4.42132 15.4167 1.25 12.2454 1.25 8.33333C1.25 4.42132 4.42132 1.25 8.33333 1.25C12.2454 1.25 15.4167 4.42132 15.4167 8.33333ZM16.6667 8.33333C16.6667 12.9357 12.9357 16.6667 8.33333 16.6667C3.73096 16.6667 0 12.9357 0 8.33333C0 3.73096 3.73096 0 8.33333 0C12.9357 0 16.6667 3.73096 16.6667 8.33333Z"
                fill={fill}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.13828 5.29H7.52828V3.75H9.13828V5.29ZM8.75163 6.66667H7.08334V7.91667H7.9183V11.25H7.08333V12.5H7.9183H9.1683H10V11.25H9.1683V7.08333C9.1683 6.85321 8.98175 6.66667 8.75163 6.66667Z"
                fill={fill}
            />
        </svg>
    );
};

